/**************************************************
 * Nombre:       Home_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import superior from '../../../Recursos/superior.png'
import inferior from '../../../Recursos/inferior.png'
import accesorios from '../../../Recursos/accesorios.png'
import Tarjeta_Categoria from "../../Tarjetas/Tarjeta_Categoria";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useContext} from "react";
import {contexApp} from "../../../App";

const Home_Categorias = () => {
    const cData = useContext(contexApp)
    const {sCell} = useResponsive()

    const obtenerImg = (cat) => {

        switch (cat) {
            case 'SUPERIOR' :
                return superior
            case 'INFERIOR' :
                return inferior
            case 'ACCESORIOS' :
                return cData.configuraciones.imgAccesorios

        }

    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 3 : 6}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{
                        fontSize: 30,
                        fontFamily: 'Dm Serif Display',
                        color: theme.palette.primary.main,
                        fontWeight: 400
                    }}>CATEGORÍAS</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'center', mt: sCell ? 8 : 12}}>
                    <Grid
                        container
                        justifyContent={sCell ? 'center' : 'space-between'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sCell ? 4 : 4}
                    >

                        {categorias.map((it, index) => {
                            return (
                                <Grid container size={{xs: 6, sm: 4, md: 4}}>
                                    <Tarjeta_Categoria item={it} img={obtenerImg(it.nombre)}/>
                                </Grid>
                            )
                        })}


                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Categorias

const categorias = [
    {
        nombre: 'SUPERIOR',
        img: superior,

    },
    {
        nombre: 'INFERIOR',
        img: inferior,

    },
    {
        nombre: 'ACCESORIOS',
        img: accesorios,

    },
]